import Vue from 'vue'
import Vuex from 'vuex'
import format from 'js/store/helpers/formatting'
Vue.use(Vuex)

const UPDATE_SAVINGS_SIMPLE_LOAN_PAYMENT_CALCULATOR =
  'updateSavingsSimpleLoanPaymentCalculator'
const UPDATE_SAVINGS_LOAN_INTEREST_CALCULATOR =
  'updateSavingsloanInterestCalculator'

export default new Vuex.Store({
  // Initial state
  state: {
    savingsLoanBalance: '10000',
    savingsLoanPrincipal: '100000',
    savingsLoanAPR: '7.5',
    savingsLoanInterest: '8.0',
    savingsLoanNumberOfYears: '30',
    savingsMinimumMonthlyPayment: '800',
    savingsMaximumMonthlyPayment: '1200',
    savingsMinimumPaymentAverageMonthlyInterest: '0.00',
    savingsMaximumPaymentAverageMonthlyInterest: '0.00'
  },

  // getters
  getters: {
    savingsLoanBalance: state => state.savingsLoanBalance,
    savingsLoanPrincipal: state => state.savingsLoanPrincipal,
    savingsLoanAPR: state => state.savingsLoanAPR,
    savingsLoanInterest: state => state.savingsLoanInterest,
    savingsLoanNumberOfYears: state => state.savingsLoanNumberOfYears,
    savingsMinimumMonthlyPayment: state => state.savingsMinimumMonthlyPayment,
    savingsMaximumMonthlyPayment: state => state.savingsMaximumMonthlyPayment,
    savingsLoanMonthlyPayment: (state, getters) => {
      if (
        getters.savingsLoanPrincipal === '' &&
        getters.savingsLoanInterest === '' &&
        getters.savingsLoanNumberOfYears === ''
      ) {
        return '0'
      }

      let months = getters.savingsLoanNumberOfYears * 12
      let monthInterest =
        parseFloat(getters.savingsLoanInterest).toFixed(6) / 1200
      let temp = 1.0 / Math.pow(1 + monthInterest, months)
      let amtPerMonth = 0.0

      if (temp < 1) {
        amtPerMonth = (
          (getters.savingsLoanPrincipal * monthInterest) /
          (1 - temp)
        ).toFixed(2)
      } else {
        amtPerMonth = (getters.savingsLoanPrincipal / months).toFixed(2)
      }

      return amtPerMonth
    },
    savingsMinimumPaymentTotalInterest: state => {
      if (
        state.savingsLoanBalance === '' &&
        state.savingsLoanAPR === '' &&
        state.savingsMinimumMonthlyPayment === '' &&
        state.savingsMaximumMonthlyPayment === ''
      ) {
        return '0.00'
      }

      let loanBalance = parseFloat(state.savingsLoanBalance)
      let monthlyRate = parseFloat(state.savingsLoanAPR).toFixed(6) / 1200
      let mm = 0
      let totalInterest = 0

      while (loanBalance > 0 && mm < 1200) {
        let monthlyInterest = loanBalance * monthlyRate
        totalInterest += monthlyInterest
        loanBalance =
          loanBalance +
          monthlyInterest -
          parseFloat(state.savingsMinimumMonthlyPayment)
        mm++
      }

      state.savingsMinimumPaymentAverageMonthlyInterest = (
        totalInterest / mm
      ).toFixed(2)
      return totalInterest.toFixed(2)
    },
    savingsMinimumPaymentAverageMonthlyInterest: state =>
      state.savingsMinimumPaymentAverageMonthlyInterest,
    savingsMaximumPaymentTotalInterest: state => {
      if (
        state.savingsLoanBalance === '' &&
        state.savingsLoanAPR === '' &&
        state.savingsMinimumMonthlyPayment === '' &&
        state.savingsMaximumMonthlyPayment === ''
      ) {
        return '0.00'
      }

      let loanBalance = parseFloat(state.savingsLoanBalance)
      let monthlyRate = parseFloat(state.savingsLoanAPR).toFixed(6) / 1200
      let mm = 0
      let totalInterest = 0

      while (loanBalance > 0 && mm < 1200) {
        let monthlyInterest = loanBalance * monthlyRate
        totalInterest += monthlyInterest
        loanBalance =
          loanBalance +
          monthlyInterest -
          parseFloat(state.savingsMaximumMonthlyPayment)
        mm++
      }

      state.savingsMaximumPaymentAverageMonthlyInterest = (
        totalInterest / mm
      ).toFixed(2)
      return totalInterest.toFixed(2)
    },
    savingsMaximumPaymentAverageMonthlyInterest: state =>
      state.savingsMaximumPaymentAverageMonthlyInterest
  },

  // actions
  actions: {
    calculateSavingsSimpleLoanPayment({ commit }, payload) {
      commit(UPDATE_SAVINGS_SIMPLE_LOAN_PAYMENT_CALCULATOR, payload)
    },

    calculateSavingsLoanInterest({ commit }, payload) {
      commit(UPDATE_SAVINGS_LOAN_INTEREST_CALCULATOR, payload)
    }
  },

  // mutations
  mutations: {
    [UPDATE_SAVINGS_SIMPLE_LOAN_PAYMENT_CALCULATOR](
      state,
      { principal, interest, years }
    ) {
      state.savingsLoanPrincipal = format.removeCommas(principal)
      state.savingsLoanInterest = interest
      state.savingsLoanNumberOfYears = format.removeCommas(years)
    },

    [UPDATE_SAVINGS_LOAN_INTEREST_CALCULATOR](
      state,
      { principal, minimumPayment, maximumPayment, interest }
    ) {
      state.savingsLoanBalance = format.removeCommas(principal)
      state.savingsMinimumMonthlyPayment = format.removeCommas(minimumPayment)
      state.savingsMaximumMonthlyPayment = format.removeCommas(maximumPayment)
      state.savingsLoanAPR = interest
    }
  }
})
